import './style.sass';

import { CrewListPropsType } from '~/components/features/cases/NextComponents/cases/moscow-exchange/team';

import CrewItem from '../crew-item/index';

const CrewContainer = ({ crewList }: CrewListPropsType) => {
    return (
        <div>
            <div className="crew__list-container">
                {crewList.map(({ crewItemTitle, crewItemSubtitle }, index) => {
                    return (
                        <CrewItem
                            key={index}
                            crewItemTitle={crewItemTitle}
                            crewItemSubtitle={crewItemSubtitle}
                        />
                    );
                })}
            </div>
        </div>
    );
};

export default CrewContainer;
